import { render, staticRenderFns } from "./CSR2021Q2.vue?vue&type=template&id=88ceec34&"
import script from "./CSR2021Q2.vue?vue&type=script&lang=js&"
export * from "./CSR2021Q2.vue?vue&type=script&lang=js&"
import style0 from "./CSR2021Q2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports